import {
  runFirestoreConnectivityTest,
  summarizePublicConfig,
} from '../../firebaseDiagnostics.js';
import { escapeHtml } from '../ui/htmlEscape.js';

/**
 * Pantalla ?fbdiag=1 (solo depuración).
 */
export function createFirebaseDiagScreen({ render, loadingView, getFirebase }) {
  return async function showFirebaseDiagView() {
    loadingView();
    const { db } = getFirebase();
    const cfg = summarizePublicConfig();
    const test = await runFirestoreConnectivityTest(db);
    const okClass = test.ok
      ? 'text-green-800 bg-green-50 border-green-200'
      : 'text-red-800 bg-red-50 border-red-200';
    render(`
    <main class="max-w-2xl mx-auto p-6 text-sm">
      <h1 class="text-xl font-semibold mb-2">Diagnóstico Firebase / Firestore</h1>
      <p class="text-slate-600 mb-4">Abrís esta pantalla con <code class="bg-slate-100 px-1 rounded">?fbdiag=1</code> en la URL (solo desarrollo / depuración).</p>
      <section class="mb-4 rounded border border-slate-200 bg-white p-4">
        <h2 class="font-medium mb-2">Configuración leída por la app (sin secretos completos)</h2>
        <ul class="list-disc pl-5 space-y-1">
          <li><strong>Project ID:</strong> <code>${escapeHtml(cfg.projectId)}</code></li>
          <li><strong>Auth domain:</strong> <code>${escapeHtml(cfg.authDomain)}</code></li>
          <li><strong>API key:</strong> <code>${escapeHtml(cfg.apiKeyHint)}</code></li>
        </ul>
      </section>
      <section class="mb-4 rounded border p-4 ${okClass}">
        <h2 class="font-medium mb-1">Prueba de conexión a Firestore</h2>
        <p class="mb-2">${escapeHtml(test.interpretacion)}</p>
        <p class="text-xs opacity-90">Tiempo: ${test.ms ?? '—'} ms ${test.code ? `· Código: <code>${escapeHtml(test.code)}</code>` : ''}</p>
        ${test.message && !test.ok ? `<p class="mt-2 text-xs whitespace-pre-wrap">${escapeHtml(test.message)}</p>` : ''}
      </section>
      <p class="mt-6"><a class="text-slate-600 underline" href="/?">Volver a la app (sin ?fbdiag)</a></p>
    </main>
  `);
  };
}
